import { Building2, BriefcaseBusiness, Handshake, Map, TrendingUp, UserRound } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

const AUDIENCE_ICONS = {
  'Owner-Managed Businesses': UserRound,
  'Field Sales Teams': Map,
  'B2B Service Providers': BriefcaseBusiness,
  'Multi-Department Organisations': Building2,
  'Referral-Led Businesses': Handshake,
  'Growing Sales Teams': TrendingUp,
};

// Section 10 — who Reach is for.
export const ReachAudiences = ({ sp }) => (
  <section aria-labelledby="reach-audiences-heading" data-testid="reach-audiences" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="10"
        eyebrow="Who It's For"
        title="Built for businesses that sell through relationships"
        testid="reach-audiences-header"
      />
      <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {(sp.industries || []).map((industry, i) => {
          const Icon = AUDIENCE_ICONS[industry.title] || Building2;
          return (
            <Reveal key={industry.title} delay={(i % 3) * 0.06} className="h-full">
              <li className="flex h-full flex-col rounded-xl border border-slate-200 bg-mist p-6" data-testid={`reach-audience-${i + 1}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-service-growth text-white">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-base font-extrabold tracking-tight text-navy-900">{industry.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{industry.text}</p>
              </li>
            </Reveal>
          );
        })}
      </ul>
    </div>
  </section>
);
